import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./StaffDashboard.css";

const StaffDashboard = () => {
  const navigate = useNavigate();
  const username = localStorage.getItem("staffUser") || "Admin";

  useEffect(() => {
    if (localStorage.getItem("staffAuth") !== "true") {
      navigate("/superadmin/login");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("staffAuth");
    localStorage.removeItem("staffUser");
    navigate("/superadmin/login");
  };

  return (
    <div className="staff-dashboard">
      {/* Header */}
      <header className="staff-db-header">
        <div className="staff-db-header-content">
          <div className="staff-db-brand">
            <div className="staff-db-shield">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </div>
            <div className="staff-db-brand-text">
              <h1>Staff Login Panel</h1>
              <span>HexaPlay Database Control Center</span>
            </div>
          </div>
          
          <div className="staff-db-actions">
            <div className="staff-db-user">
              <span className="staff-db-username">{username}</span>
            </div>
            <button className="staff-db-logout" onClick={handleLogout}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Logout
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="staff-db-main">
        <div className="staff-db-container">
          {/* Welcome Section */}
          <div className="staff-db-welcome">
            <h2>
              👋 Welcome back, <span className="staff-db-gradient-text">{username}</span>
            </h2>
            <p>Here's what's happening with your business today.</p>
          </div>

          {/* Stats Grid */}
          <div className="staff-db-stats">
            <div className="staff-stat-card">
              <div className="staff-stat-icon blue">🎭</div>
              <div className="staff-stat-info">
                <span className="staff-stat-label">Total Theaters</span>
                <strong className="staff-stat-value">3</strong>
              </div>
            </div>
            
            <div className="staff-stat-card">
              <div className="staff-stat-icon purple">📅</div>
              <div className="staff-stat-info">
                <span className="staff-stat-label">Total Bookings</span>
                <strong className="staff-stat-value">69</strong>
              </div>
            </div>
            
            <div className="staff-stat-card">
              <div className="staff-stat-icon pink">📞</div>
              <div className="staff-stat-info">
                <span className="staff-stat-label">Total Inquiries</span>
                <strong className="staff-stat-value">41</strong>
              </div>
            </div>
            
            <div className="staff-stat-card">
              <div className="staff-stat-icon orange">🔒</div>
              <div className="staff-stat-info">
                <span className="staff-stat-label">Admin-Blocked Slots</span>
                <strong className="staff-stat-value">1</strong>
              </div>
            </div>
          </div>

          {/* Admin Tools Section */}
          <div className="staff-db-section">
            <h3 className="staff-section-title">
              <span className="staff-lightning">⚡</span>
              Admin Tools
            </h3>

            <div className="staff-cards-grid single-card">
              {/* View All Database Card */}
              <div className="staff-card database-card">
                <div className="staff-card-icon-wrap pink-gradient">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <ellipse cx="12" cy="5" rx="9" ry="3" />
                    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
                    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
                  </svg>
                </div>
                
                <h4 className="staff-card-title">View All Database</h4>
                <p className="staff-card-desc">
                  All paid customer inquiries in one place
                </p>
                
                <button 
                  className="staff-card-btn pink-btn"
                  onClick={() => navigate("/StaffManagement")}
                >
                  Open Database <span>→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default StaffDashboard;